import script from "./AboutComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutComponent.vue?vue&type=style&index=0&id=201ead11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201ead11"]])

export default __exports__